module.exports = __webpack_public_path__ + "img/NCL.d9ac80e1.svg";